const notEmpty = (value: string | Array<any>): boolean =>
  !!value?.length;
const mayBeEmpty =
  (param: Function) =>
  (value: string | Array<any>): boolean => {
    return value?.length ? param(value) : true;
  };

export { notEmpty, mayBeEmpty };



// WEBPACK FOOTER //
// ./src/tools/validators/notEmpty.ts